import React from "react";
import style from "./Details.module.css";
export default function Details() {
  return (
    <div className={style.mainContainer}>
      <div className={style.innerContainer}>
        <h2 className={style.getInTouch}>
          GET IN <strong>TOUCH</strong> WITH US
        </h2>
        <h6 className={style.genQuery}>General Query</h6>
        <p className={style.genEmail}>info@invozone.com</p>
        <h6 className={style.careers}>Careers</h6>
        <p className={style.careersEmail}>hr@invozone.com</p>

        <h2 className={style.globalP}>
          OUR <strong>GLOBAL</strong> PRESENCE
        </h2>

        <h6 className={style.contactHead}>Malaysia - Head Office</h6>
        <p className={style.contactDesc}>
          F2-2-1, Midfields 2, Sungai Besi,<br></br>
          57100, Kuala Lumpur, Malaysia
        </p>
        <p className={style.contactPhone}>Phone: +60-11-2323-4533</p>

        <h6 className={style.contactHead}>Pakistan – Regional Office</h6>
        <p className={style.contactDesc}>
          nvoZone, 1st Floor, Commercial 3, Sunflower,<br></br>
          Block J1, Johar Town, Lahore
        </p>
        <p className={style.contactPhone}>Phone: +92-31-777-111-71</p>
      </div>
    </div>
  );
}
